module.exports = __webpack_public_path__ + "img/ppt-4.e0cf8a3e.webp";